<dx-drop-down-box [showClearButton]="false" fieldTemplate="field">
	<div *dxTemplate="let data of 'field'">
		<dx-text-box [value]="getTextBoxValue()"></dx-text-box>
	</div>
	<div *dxTemplate="let data of 'content'">
		<div *ngFor="let datarow of dataSource" class="dropdown-row">
			<dx-check-box [value]="datarow.Selected" [text]="datarow.Value" (onValueChanged)="onDropdownSelectionChanged($event, datarow)"></dx-check-box>
		</div>
	</div>
</dx-drop-down-box>
